import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { showError } from '@store/logged/actions';
import { hideLoading, showLoading } from '@store/common/actions';
import { getZipCodes } from '@services/util-service';

const useZipCode = () => {
  const dispatch = useDispatch();
  const [zipCodes, setZipCodes] = useState([]);

  useEffect(() => {
    dispatch(showLoading());
    getZipCodes()
      .then((response) => setZipCodes(response?.zip_code))
      .catch((error) => dispatch(showError(error)))
      .finally(() => dispatch(hideLoading()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    zipCodes,
  };
};

export default useZipCode;
